import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
  standalone: true,
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(phoneValue: number | string | null | undefined): string {
    if (phoneValue === null || phoneValue === undefined || phoneValue === '') {
      return '';
    }
    const stringPhone = phoneValue + '';
    try {
      return parsePhoneNumber(stringPhone, 'US').formatNational();
    } catch {
      // Legacy rows can hold values libphonenumber cannot parse; render the
      // raw value instead of throwing inside change detection.
      return stringPhone;
    }
  }
}
